const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/appointment/BookingConfirmationPage.tsx';
import { RouteComponentProps } from 'react-router';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import * as React from 'react';
import textMap from 'App/pages/appointment/translations';
import { IconClass } from '@cistec/common_web/defs/icons';
import { Page } from '../Page';
import { Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import { AppointmentTitleRow } from './components/AppointmentTitleRow';
import { AppointmentTimeRow } from './components/AppointmentTimeRow';
import { AppointmentDetailsRow } from './components/AppointmentDetailsRow';
import { AppointmentAddToCalendarRow } from './components/AppointmentAddToCalendarRow';
import { AppointmentLocationRow } from './components/AppointmentLocationRow';
import { AppoinmentButtonsRow } from './components/AppoinmentButtonsRow';
import { currentPatientFromEmailLogin } from '@cistec/common_web/selectors/patientsSelectors';
import { GoToAppointmentListButton } from './components/GoToAppointmentListButton';
import { GoToAppointmentBookingButton } from './components/GoToAppointmentBookingButton';
import { AppointmentMessageRow } from './components/AppointmentMessageRow';
import { useStructuredAppointment } from 'App/store/appointment';

export interface IBookingConfirmationPageProps {}

interface IRouteParams {
    termnr: string;
}

export const BookingConfirmationPage = (props: IBookingConfirmationPageProps & RouteComponentProps<IRouteParams>) => {
    const { formatMessage } = useIntl();

    const currentPatFromEmail = useSelector(currentPatientFromEmailLogin);

    const terminNr = props.match.params.termnr;
    const { data: appointment } = useStructuredAppointment(terminNr);
    if (!appointment) return null;

    return (
        <Page title={formatMessage(textMap.terminGebucht)} iconClass={IconClass.Calendar}>
            <Grid container spacing={2}>
                <AppointmentTitleRow appointment={appointment} />
                <AppointmentTimeRow appointment={appointment} />
                <AppointmentDetailsRow appointment={appointment} />
                <AppointmentMessageRow text={formatMessage(textMap.bookingConfirmationMessage)} />
                <AppointmentAddToCalendarRow appointment={appointment} />
                {currentPatFromEmail ? null : (
                    <Grid size={{ xs: 12 }}>
                        <Typography>{formatMessage(textMap.appointmentMutationInformation)}</Typography>
                    </Grid>
                )}
                <AppointmentLocationRow appointment={appointment} />
                <AppoinmentButtonsRow>
                    <GoToAppointmentListButton />
                    <GoToAppointmentBookingButton text={formatMessage(textMap.bookMoreAppointments)} />
                </AppoinmentButtonsRow>
            </Grid>
        </Page>
    );
};
